/**
 * defa.views.PhoneNumberUpdateForm
 * A card for updating PhoneNumbers.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/phoneNumberUpdateForm.jst.html';

const selectors             = {
	inputDescription: '[data-input=phone-number-description]',
	inputNumber     : '[data-input=phone-number-number]',
	inputPrefix     : '[data-input=phone-number-prefix]',
};
const PhoneNumberUpdateForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		description: selectors.inputDescription,
		number     : selectors.inputNumber,
		prefix     : selectors.inputPrefix,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Fill the prefix select element with all available options.
	 * @void
	 */
	onRender: function () {
		
		this.ui.number.intlTelInput( {
			preferredCountries: [ 'no', 'se', 'dk', 'fi', ],
			utilsScript       : '/assets/vendor/intl-tel-input-utils.min.js',
			autoPlaceholder   : 'off',
			separateDialCode  : true,
		} );
		this.ui.number.intlTelInput( 'setNumber', this.model.get( 'prefix' ) + this.model.get( 'number' ) );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attempts to save the information to the Model.
	 * @void
	 */
	submit: function () {
		
		let prefix = '+' + this.ui.number.intlTelInput( 'getSelectedCountryData' ).dialCode.trim(),
			number = this.ui.number.intlTelInput( 'getNumber' ).replace( prefix, '' ).trim();
		
		let form = {
			user       : this.options.currentUser.get( 'id' ),
			prefix     : prefix,
			number     : number,
			description: this.ui.description.val().trim(),
		};
		
		this.model.save( form );
	},
	
} );

export default PhoneNumberUpdateForm;